<template>
    <nav class="pagination">
        <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1" class="button__arrow left"><svg width="6.302734" height="11.305298" viewBox="0 0 6.30273 11.3053" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs/>
            <path id="Vector" d="M5.65 10.65L0.65 5.65L5.65 0.65" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.300000" stroke-linejoin="round" stroke-linecap="round"/>
            </svg>
        </button>
        <div class="pagination__flip">
            <button 
            v-for="page in pages" 
            :key="page" 
            @click="goToPage(page)" 
            :class="{ dots: page === '...', active: page === currentPage }"
            :disabled="page === '...' || page === currentPage"
            >
            <span v-if="page === '...'" class="dots">
        <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <circle cx="2" cy="2" r="2" fill="#DEE6EA"/>
            <circle cx="8" cy="2" r="2" fill="#DEE6EA"/>
            <circle cx="14" cy="2" r="2" fill="#DEE6EA"/>
          </g>
        </svg>
      </span>
      <span v-else>{{ page }}</span>
            </button>
        </div>
        <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages" class="button__arrow right">
            <svg width="6.302612" height="11.305298" viewBox="0 0 6.30261 11.3053" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs/>
        <path id="Vector" d="M0.65 0.65L5.65 5.65L0.65 10.65" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.300000" stroke-linejoin="round" stroke-linecap="round"/>
    </svg>
    </button>
    </nav>
  </template>
  
  <script>
  import { computed } from 'vue';
  
  export default {
    props: {
      totalPages: { type: Number, required: true },
      currentPage: { type: Number, required: true, default: 1 }
    },
    emits: ["update:currentPage"],
    computed: {
      pages() {
        const { totalPages, currentPage } = this;
        const pagesArray = [];
        
        if (totalPages <= 5) {
          return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        
        if (currentPage <= 3) {
          pagesArray.push(1, 2, 3, 4);
          if (totalPages > 5) pagesArray.push("...");
          pagesArray.push(totalPages);
        } else if (currentPage >= totalPages - 2) {
          pagesArray.push(1);
          if (totalPages > 5) pagesArray.push("...");
          pagesArray.push(totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
        } else {
          pagesArray.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
        }
  
        return pagesArray;
      }
    },
    methods: {
      goToPage(page) {
        if (typeof page === "number") {
          this.$emit("update:currentPage", page);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .pagination {
    margin-top: 64px;
    display: flex;
    gap: 16px;
    justify-content: center;
  }
  .pagination__flip{
    display: flex;
    gap: 12px;
  }
  .pagination__flip button{
    box-sizing: border-box;
    border: 1px solid rgb(222, 230, 234);
    border-radius: 32px;
    background: rgb(255, 255, 255);
    width: 32px;
    height: 32px;
    color: rgb(15, 28, 55);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
  }
  .pagination__flip button:disabled{
    background: rgb(255, 183, 16);
    opacity: 1;
    cursor: not-allowed;
  }
  .pagination__flip button.dots:disabled{
    background: unset;
    border: unset;
    opacity: 1;
    cursor: not-allowed;
    width: unset;
    height: unset;
    display: flex;
    align-items: end;
  }
  .button__arrow:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .button__arrow{
    box-sizing: border-box;
    border: 1px solid rgb(222, 230, 234);
    background: rgb(255, 255, 255);
    width: 32px;
    height: 32px;
    transition: all 0.5s;
    border-radius: 100%;
  }
  button:hover{
    background: rgb(255, 183, 16);
  }
  .button__arrow:disabled:hover {
    background: rgb(255, 255, 255);
    opacity: 0.5;
    cursor: not-allowed;
  }
  </style>
  